const generateZPL = (
  ruta: string,
  container: string,
  id: string,
  stop: string,
  point: string,
  date: string,
  step: string,
) => {
  return `^XA
    ^FO5,5
    ^GB396,192,2,,2
    ^FS
    
    ^FO5,150
    ^GB396,2,2
    ^FS
    
    ^FO198,150
    ^GB2,45,2
    ^FS
    
    ^FO270,5
    ^GB2,145,2
    ^FS
    
    ^FO270,80
    ^GB130,2,2
    ^FS
    
    ^FO20,14
    ^CFA,15,10
    ^FDRUTA
    ^FS
    
    ^FO15,45
    ^CFA,60,25
    ^FD${container}
    ^FS
    
    ^FO20,115
    ^CFA,30,15
    ^FD${ruta}
    ^FS

    ^FO190,14
    ^CFA,15,10
    ^FD${step}
    ^FS
    
    ^FO20,166
    ^CFA,15,10
    ^FDDT:
    ^FS
    
    ^FO55,166
    ^CFA,15,8
    ^FD ${date}
    ^FS
    
    ^FO205,166
    ^CFA,15,10
    ^FDID:
    ^FS
    
    ^FO230,166
    ^CFA,15,8
    ^FD ${id}
    ^FS
    
    ^FO280,18
    ^CFA,15,10
    ^FDPARADA
    ^FS
    
    ^FO280,50
    ^CFA,15,10
    ^FD${stop}
    ^FS
    
    ^FO280,90
    ^CFA,15,10
    ^FDPUNTO
    ^FS
    
    ^FO290,125
    ^CFA,15,10
    ^FD${point}
    ^FS
    
    ^FO280,115
    ^GB30,30,2,,8
    ^FS
    
    ^XZ`;
};
export { generateZPL };

export const generateZPLContainer = (
  container: string,
  container_name: string,
  route: string,
) => {
  return `^XA

    ^FO250, 50
    ^BQN,2,10
    ^FDM,${container}^FS
   
    ^FO170,400
    ^CFA,150,40
    ^FDCONTENEDOR
    ^FS
    
    ^FO280,490
    ^CFA,150,40
    ^FD${container_name}
    ^FS

    ^FO300,600
    ^CFA,150,40
    ^FDRUTA
    ^FS
    
    ^FO280,690
    ^CFA,150,40
    ^FD${route}
    ^FS

    ^XZ`;
};
